import { render, staticRenderFns } from "./DonationForm.vue?vue&type=template&id=0599bc41"
import script from "./DonationForm.vue?vue&type=script&lang=js"
export * from "./DonationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\lifeline-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0599bc41')) {
      api.createRecord('0599bc41', component.options)
    } else {
      api.reload('0599bc41', component.options)
    }
    module.hot.accept("./DonationForm.vue?vue&type=template&id=0599bc41", function () {
      api.rerender('0599bc41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/style-two/DonationForm.vue"
export default component.exports